/* ==========================================================================
   BONPEK — Formula Finder
   --------------------------------------------------------------------------
   Three taps (age / milk base / need) narrow the live formula catalogue and
   show what is actually on the shelf right now.

   Data comes from templates/collection.finder-json.liquid, fetched lazily the
   first time the section scrolls into view.

   DO NOT send an Accept: application/json header on that fetch. Shopify sees
   it and answers with its OWN collection JSON endpoint instead of rendering
   the finder-json template — 200 OK, correct content-type, completely wrong
   payload, and the Finder silently shows "we can't load the shelf". Learned
   the hard way on 22 Sep 2026.

   Prices are NOT formatted here. The endpoint sends each price already run
   through Liquid's money filter, so the Finder always matches whatever money
   format the shop is set to. Formatting it here would silently fork the two.

   Config arrives on the root element as data attributes so this file stays a
   cacheable static asset with no Liquid in it.
   ========================================================================== */
(function () {
  "use strict";

  /* ---------- icon set ------------------------------------------------
     Drawn for this section. One 24x24 viewBox each, a soft filled shape
     (opacity .18-.22) under crisp 1.7 strokes, so they read as little logos
     rather than generic line glyphs. Two are fragile:
       - the goat's horns are OPEN tapering strokes. Close those paths and it
         reads as a rabbit. Do not "tidy" them into closed shapes.
       - the cow needs both the ears and the small horns; drop either and it
         turns into a dog.
     ------------------------------------------------------------------- */
  function svg(inner) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" ' +
           'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + inner + '</svg>';
  }

  var I = {
    qAge: svg('<circle cx="12" cy="12.6" r="7.4" fill="currentColor" fill-opacity=".18"/><circle cx="12" cy="12.6" r="7.4"/><path d="M12 5.2c.9-1.3 2.5-1.1 2.7.3"/><path d="M9.6 11.6h.01M14.4 11.6h.01"/><path d="M9.5 14.9c1.5 1.4 3.5 1.4 5 0"/>'),
    qMilk: svg('<path d="M7 21V9.6l1.8-3V3h6.4v3.6L17 9.6V21z" fill="currentColor" fill-opacity=".18"/><path d="M8.8 3h6.4v3.6L17 9.6V19a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V9.6l1.8-3z"/><path d="M7 12h10"/>'),
    qNeed: svg('<path d="M12 20S4.8 15.6 4.8 10.4A3.8 3.8 0 0 1 12 8.6a3.8 3.8 0 0 1 7.2 1.8C19.2 15.6 12 20 12 20z" fill="currentColor" fill-opacity=".18"/><path d="M12 20S4.8 15.6 4.8 10.4A3.8 3.8 0 0 1 12 8.6a3.8 3.8 0 0 1 7.2 1.8C19.2 15.6 12 20 12 20z"/><path d="M6.6 12.2h2.6l1.2-2 1.6 3.4 1.3-2.2h3.1"/>'),

    bottle: svg('<path d="M8 13.4h8V18a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3z" fill="currentColor" fill-opacity=".22"/><path d="M10.4 2.6h3.2v2.1c0 .8.3 1.5.9 2l.6.6c.3.3.5.8.5 1.3V18a3 3 0 0 1-3 3h-1.2a3 3 0 0 1-3-3V8.6c0-.5.2-1 .5-1.3l.6-.6c.6-.5.9-1.2.9-2z"/><path d="M8.4 7.3h7.2"/><path d="M8 11h2.4M8 14.6h2.4"/>'),
    sippy: svg('<path d="M8.6 13.6h6.8V18a3 3 0 0 1-3 3h-.8a3 3 0 0 1-3-3z" fill="currentColor" fill-opacity=".22"/><path d="M8.6 8.2h6.8V18a3 3 0 0 1-3 3h-.8a3 3 0 0 1-3-3z"/><path d="M9.2 8.2 10.2 5.4A1.6 1.6 0 0 1 11.7 4.3h.6a1.6 1.6 0 0 1 1.5 1.1l1 2.8"/><path d="M12 4.3V2.6"/><path d="M8.6 10.6H6.5a1.9 1.9 0 0 0 0 3.8h2.1M15.4 10.6h2.1a1.9 1.9 0 0 1 0 3.8h-2.1"/>'),
    cup: svg('<path d="M8.5 13.8h7l-.6 5A2.4 2.4 0 0 1 12.5 21h-1a2.4 2.4 0 0 1-2.4-2.2z" fill="currentColor" fill-opacity=".22"/><path d="M7.4 7.6h9.2l-1.5 11.2A2.4 2.4 0 0 1 12.7 21h-1.4a2.4 2.4 0 0 1-2.4-2.2z"/><path d="M6.4 7.6h11.2"/>'),
    straw: svg('<path d="M8.9 14.2h6.2l-.5 4.6A2.4 2.4 0 0 1 12.2 21h-.4a2.4 2.4 0 0 1-2.4-2.2z" fill="currentColor" fill-opacity=".22"/><path d="M7.9 9.6h8.2l-1.2 9.2A2.4 2.4 0 0 1 12.5 21h-1a2.4 2.4 0 0 1-2.4-2.2z"/><path d="M6.9 9.6h10.2"/><path d="m13.9 9.6 2.6-6.2"/><path d="m14.9 3.1 3 .8"/>'),

    cow: svg('<path d="M8.5 13.8h7a.9.9 0 0 1 .9.9v1.1a4.4 4.4 0 0 1-8.8 0v-1.1a.9.9 0 0 1 .9-.9z" fill="currentColor" fill-opacity=".22"/><path d="M6.2 10.6c0-2.6 2.6-4.7 5.8-4.7s5.8 2.1 5.8 4.7v1.3c0 1.5-.7 2.8-1.9 3.6"/><path d="M7.9 15.5c-1.2-.8-1.7-2.1-1.7-3.6"/><path d="M8.5 13.8h7a.9.9 0 0 1 .9.9v1.1a4.4 4.4 0 0 1-8.8 0v-1.1a.9.9 0 0 1 .9-.9z"/><path d="M6.3 10.1c-1.7-1-3.4-.9-4.2.3.6 1.3 2.2 2 3.9 1.6"/><path d="M17.7 10.1c1.7-1 3.4-.9 4.2.3-.6 1.3-2.2 2-3.9 1.6"/><path d="M8.9 6.5c-.7-1.5-.2-2.7 1.1-2.9"/><path d="M15.1 6.5c.7-1.5.2-2.7-1.1-2.9"/><path d="M10.7 6.2c.5-1 1.9-1 2.5 0"/><path d="M10 11.5h.01M14 11.5h.01"/><path d="M10.9 15.9h.01M13.1 15.9h.01"/>'),
    goat: svg('<path d="M8.3 12.1c0-2.3 1.7-4.1 3.7-4.1s3.7 1.8 3.7 4.1v1.1c0 2.5-1.7 4.5-3.7 4.5s-3.7-2-3.7-4.5z" fill="currentColor" fill-opacity=".22"/><path d="M10.4 8.3C9.8 6.4 8.4 5 6.5 4.2" stroke-width="2.1"/><path d="M13.6 8.3c.6-1.9 2-3.3 3.9-4.1" stroke-width="2.1"/><path d="M8.3 12.1c0-2.3 1.7-4.1 3.7-4.1s3.7 1.8 3.7 4.1v1.1c0 2.5-1.7 4.5-3.7 4.5s-3.7-2-3.7-4.5z"/><path d="M8.4 12.5c-1.7-.3-3 .2-3.8 1.4 1.2 1 2.6 1.1 4 .4"/><path d="M15.6 12.5c1.7-.3 3 .2 3.8 1.4-1.2 1-2.6 1.1-4 .4"/><path d="M11.1 17.6c.2 1.7.5 2.8.9 3.2.4-.4.7-1.5.9-3.2"/><path d="M10.6 12.1h.01M13.4 12.1h.01"/><ellipse cx="12" cy="15.2" rx="1.1" ry=".8"/>'),
    both: svg('<path d="M9 4.8c1.9 2.4 2.9 4.2 2.9 5.6a2.9 2.9 0 1 1-5.8 0c0-1.4 1-3.2 2.9-5.6z" fill="currentColor" fill-opacity=".22"/><path d="M9 4.8c1.9 2.4 2.9 4.2 2.9 5.6a2.9 2.9 0 1 1-5.8 0c0-1.4 1-3.2 2.9-5.6z"/><path d="M15 10.6c1.9 2.4 2.9 4.2 2.9 5.6a2.9 2.9 0 1 1-5.8 0c0-1.4 1-3.2 2.9-5.6z"/>'),

    ok: svg('<circle cx="12" cy="12" r="8.2" fill="currentColor" fill-opacity=".18"/><circle cx="12" cy="12" r="8.2"/><path d="m8.4 12.2 2.4 2.4 4.8-5"/>'),
    reflux: svg('<path d="M6.4 9.6a5.6 5.6 0 0 1 11.2 0v4.8a5.6 5.6 0 0 1-11.2 0z" fill="currentColor" fill-opacity=".22"/><path d="M6.4 9.6a5.6 5.6 0 0 1 11.2 0v4.8a5.6 5.6 0 0 1-11.2 0z"/><path d="M12 17.2V7.4"/><path d="M9.4 10 12 7.4l2.6 2.6"/>'),
    colic: svg('<circle cx="12" cy="12.4" r="7.6" fill="currentColor" fill-opacity=".18"/><circle cx="12" cy="12.4" r="7.6"/><path d="M8.7 10.9c.6-.8 1.7-.8 2.3 0M13 10.9c.6-.8 1.7-.8 2.3 0"/><ellipse cx="12" cy="15.4" rx="2" ry="1.6"/><path d="M16.6 13.1c.8 1.2 1 1.8.5 2.3a1 1 0 0 1-1.6-.4c-.2-.6.3-1.1 1.1-1.9z"/>'),
    gas: svg('<circle cx="11.6" cy="14.4" r="6.2" fill="currentColor" fill-opacity=".18"/><circle cx="11.6" cy="14.4" r="6.2"/><circle cx="18.2" cy="5.6" r="1.8"/><circle cx="14.4" cy="3.9" r="1.1"/><path d="M8.4 14.6c1.2-1.7 2.2.9 3.2 0s1.8-1.7 3 0"/>'),
    ha: svg('<path d="M12 3.2 19 6v6c0 4.3-3.1 7.2-7 8-3.9-.8-7-3.7-7-8V6z" fill="currentColor" fill-opacity=".18"/><path d="M12 3.2 19 6v6c0 4.3-3.1 7.2-7 8-3.9-.8-7-3.7-7-8V6z"/><path d="M12 14.6s-3-1.9-3-4a1.7 1.7 0 0 1 3-.9 1.7 1.7 0 0 1 3 .9c0 2.1-3 4-3 4z"/>'),
    cmpa: svg('<path d="M12 3.2 19 6v6c0 4.3-3.1 7.2-7 8-3.9-.8-7-3.7-7-8V6z" fill="currentColor" fill-opacity=".18"/><path d="M12 3.2 19 6v6c0 4.3-3.1 7.2-7 8-3.9-.8-7-3.7-7-8V6z"/><path d="M12 8.4v6M9 11.4h6"/>'),
    lactose: svg('<path d="M12 3.6c3 3.8 4.6 6.6 4.6 8.8a4.6 4.6 0 1 1-9.2 0c0-2.2 1.6-5 4.6-8.8z" fill="currentColor" fill-opacity=".18"/><path d="M12 3.6c3 3.8 4.6 6.6 4.6 8.8a4.6 4.6 0 1 1-9.2 0c0-2.2 1.6-5 4.6-8.8z"/><path d="m5.6 19.4 12.8-13.6"/>'),
    search: svg('<circle cx="11" cy="11" r="7"/><path d="M20 20l-3.6-3.6"/>')
  };

  var GROUPS = [
    { k: "age", cls: "bpff-qb--age", ico: "qAge", cols: 2,
      q: "How old is your baby?",
      o: [["birth", "0–6 months", "PRE &amp; Stage 1", "bottle"],
          ["m6", "6–12 months", "Stage 2", "sippy"],
          ["m12", "12–24 months", "Stage 3", "cup"],
          ["m24", "24+ months", "Stage 4 &amp; Junior", "straw"]] },
    { k: "milk", cls: "bpff-qb--milk", ico: "qMilk", cols: 3,
      q: "Cow milk or goat milk?", sub: "Most parents pick “show me both”",
      o: [["cow", "Cow milk", "", "cow"], ["goat", "Goat milk", "", "goat"], ["any", "Both", "", "both"]] },
    { k: "need", cls: "bpff-qb--need", ico: "qNeed", cols: 2,
      q: "Anything you're dealing with?", sub: "Pick one, or skip it",
      o: [["none", "Nothing in particular", "", "ok"],
          ["reflux", "Spitting up", "Reflux, posseting", "reflux"],
          ["colic", "Colic or constipation", "", "colic"],
          ["tummy", "Gassy or upset tummy", "", "gas"],
          ["ha", "Baby is having allergic reactions", "Not diagnosed", "ha"],
          ["cmpa", "Diagnosed milk allergy", "CMPA or CMA", "cmpa"],
          ["lactose", "Lactose intolerance", "Diagnosed or suspected", "lactose"]] }
  ];

  var BRAND = { hipp: "var(--bpff-forest)", holle: "var(--bpff-rose)", kendamil: "var(--bpff-slate)",
                aptamil: "var(--bpff-action)", jovie: "var(--bpff-gold)", nannycare: "var(--bpff-action-lt)" };

  /* ====================================================================
     AGE — THE TAG SET IS A RANGE, NOT A BUCKET       rewritten 23 Sep 2026
     --------------------------------------------------------------------
     THE BUG THIS REPLACES. The old code sorted each Age_ tag into one of
     four buckets with a regex — /^6 Month|^8 Month|^10 Month/ all became
     "6-12 months". So Holle Stage 3 Goat Dutch, tagged 10 / 12 / 15 Months
     & Over, came out as buckets [m6, m12] and the card read "6-24 months"
     on a tin that does not start until 10 months. It was also offered to
     anyone who said their baby was 6-12 months old. Every 8-month and
     10-month product in the catalogue had the same fault.

     THE MODEL, which is how Bonpek actually tags: the Age_ tags are rungs
     on a ladder, and a product carries EVERY rung at which it is suitable.
     So the set as a whole states a range:

         min = the lowest rung tagged
         max = the NEXT RUNG ABOVE the highest one tagged (exclusive)

     Worked examples from the live catalogue:
       From Birth On, 4, 5          -> 0 to 6      (PRE / Stage 1)
       6, 8, 10                     -> 6 to 12     (Stage 2)
       10, 12, 15                   -> 10 to 24    (Holle Stage 3)
       12, 15, 24                   -> 12 to 36    (NannyCare Stage 3)
       12, 15, 24, 36               -> 12 to 48    (Stage 4 / growing-up)

     THIS CUTS BOTH WAYS. Because the highest rung sets the upper bound, an
     extra rung is not harmless padding — it extends the age range of the
     product. NannyCare 1 used to carry 6, 8 and 10 on top of From Birth On,
     which read as a 0-12 tin when it is 0-6; NannyCare 3 carried 36, which
     pushed a 12-36 tin out to four years. Both were corrected on 23 Sep.
     Tag a product with the rungs it is actually for, and no more.

     MATCHING. A product is offered for an age bucket only when it is
     suitable AT THE START of that bucket:  min <= bucketStart < max.
     A parent who says "6-12 months" is asking for a formula they can use
     now, not one that becomes appropriate four months later — which is why
     the 10-month Stage 3 no longer appears there. Verified against all 75
     formulas: every product still lands in at least one bucket.

     If a rung is ever added to the tag vocabulary, add it to AGE_LADDER in
     order. Nothing else needs to change.
     ==================================================================== */
  var AGE_LADDER = [0, 4, 5, 6, 8, 10, 12, 15, 24, 36, 48];
  var AGE_KEYS = ["birth", "m6", "m12", "m24"];
  var AGE_START = { birth: 0, m6: 6, m12: 12, m24: 24 };
  var AGE_END = { birth: 6, m6: 12, m12: 24, m24: null };
  var AGEL = { birth: "0–6 months", m6: "6–12 months", m12: "12–24 months", m24: "24+ months" };
  var NEEDL = { reflux: "spitting up or reflux", colic: "colic or constipation",
                tummy: "a gassy or upset tummy", ha: "sensitivity to cow's milk",
                cmpa: "a diagnosed cow's milk allergy", lactose: "lactose intolerance" };
  var MILKL = { cow: "cow milk", goat: "goat milk", any: "" };
  var NARROW = 900;

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c];
    });
  }
  function push(a, v) { if (a.indexOf(v) < 0) a.push(v); }

  /* "From Birth On" -> 0 · "10 Months & Over" -> 10 · "4 Years+" -> 48 */
  function tagMonths(a) {
    if (/^From Birth/i.test(a)) return 0;
    if (/^4 Year/i.test(a)) return 48;
    var m = a.match(/^(\d+)\s*Month/i);
    return m ? parseInt(m[1], 10) : null;
  }

  /* The label states the product's own range, straight off the tags, so it
     can never claim an age the tin does not carry. Past 36 months it switches
     to years, because "12–48 months" is not how anyone speaks. A tin tagged
     to the very top rung has no upper bound to state at all. */
  function ageLabel(min, max) {
    if (min === null) return "age not tagged";
    if (max === null) return min === 0 ? "every stage" : min + "+ months";
    if (max >= 48) return min + " months – 4 years";
    return min + "–" + max + " months";
  }

  /* ---------- tags are the single source of truth ----------------------
     A re-tagged product changes the Finder without anyone editing this file.
       Age_*                                      -> the range, see above
       Attribute_From Cow Milk / From Goat Milk   -> milk base
       Attribute_Help with Acid Reflux
         | Help with Spitting Up                  -> reflux
       Attribute_Colic Relief
         | Help with Constipation                 -> colic
       Attribute_Help with Upset Stomach          -> tummy
       Attribute_HA Hypoallergenic                -> ha   (partially hydrolysed)
       Attribute_Cow's Milk Allergy               -> cmpa (extensively hydrolysed)
       Attribute_Lactose Free                     -> lactose
     "Reduced Lactose Content" deliberately does NOT map to lactose — a comfort
     formula is not a lactose-free formula and must not be offered as one.
     ------------------------------------------------------------------- */
  function mapProduct(p) {
    var g = p.g || [], months = [], need = [], milk = "", i, t, s, v;
    for (i = 0; i < g.length; i++) {
      t = g[i];
      if (t.indexOf("Age_") === 0) {
        v = tagMonths(t.slice(4));
        if (v !== null) push(months, v);
      } else if (t.indexOf("Attribute_") === 0) {
        s = t.slice(10);
        if (s === "From Cow Milk") milk = "cow";
        else if (s === "From Goat Milk") milk = "goat";
        else if (s === "Help with Acid Reflux" || s === "Help with Spitting Up") push(need, "reflux");
        else if (s === "Colic Relief" || s === "Help with Constipation") push(need, "colic");
        else if (s === "Help with Upset Stomach") push(need, "tummy");
        else if (s === "HA Hypoallergenic") push(need, "ha");
        else if (s === "Cow's Milk Allergy") push(need, "cmpa");
        else if (s === "Lactose Free") push(need, "lactose");
      }
    }

    var min = null, max = null, age = [];
    if (months.length) {
      months.sort(function (x, y) { return x - y; });
      min = months[0];
      var top = months[months.length - 1];
      var at = AGE_LADDER.indexOf(top);
      max = (at < 0 || at === AGE_LADDER.length - 1) ? null : AGE_LADDER[at + 1];
      age = AGE_KEYS.filter(function (k) {
        var s0 = AGE_START[k];
        return min <= s0 && (max === null || max > s0);
      });
    }

    return { b: p.b || "", h: p.h, t: p.t, img: p.m || "", money: p.f || "",
             price: (p.p || 0) / 100, qty: (typeof p.q === "number" ? p.q : 0), avail: !!p.a,
             age: age, ageMin: min, ageMax: max, milk: milk, need: need };
  }

  function getJSON(url) {
    /* No Accept header — see the note at the top of this file. */
    return fetch(url, { credentials: "same-origin" }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }

  function init(ROOT) {
    if (!ROOT || ROOT.dataset.bpffReady === "1") return;
    ROOT.dataset.bpffReady = "1";

    var PHONE = ROOT.dataset.phone || "";
    var EYEBROW = ROOT.dataset.eyebrow || "Formula Finder";
    var BASE = (ROOT.dataset.src || "/collections/all-baby-formulas?view=finder-json");
    var COLLECTION_URL = BASE.split("?")[0];

    var S = { age: null, milk: null, need: null };
    var P = null, LOADING = false, FAILED = false, EXPANDED = false;
    var TOTAL = parseInt(ROOT.dataset.total, 10) || 70;

    function $(n) { return ROOT.querySelector('[data-bpff="' + n + '"]'); }

    function loadCatalogue() {
      if (P || LOADING || FAILED) return Promise.resolve();
      LOADING = true;
      return getJSON(BASE + "&page=1").then(function (d) {
        if (!d || !d.products) throw new Error("unexpected payload");
        var all = d.products.slice(), rest = [], i;
        for (i = 2; i <= d.pages; i++) rest.push(getJSON(BASE + "&page=" + i));
        if (d.total) TOTAL = d.total;
        return Promise.all(rest).then(function (pages) {
          pages.forEach(function (x) { all = all.concat(x.products || []); });
          return all;
        });
      }).then(function (list) {
        P = list.map(mapProduct);
        LOADING = false;
        render();
      })["catch"](function () {
        /* Most likely templates/collection.finder-json.liquid is missing on
           this theme, so Shopify served something else entirely. */
        LOADING = false; FAILED = true;
        render();
      });
    }

    function sel(ignore) {
      if (!P) return [];
      return P.filter(function (p) {
        if (!ignore.age && S.age && p.age.indexOf(S.age) < 0) return false;
        /* When the age filter is relaxed we still never go UPWARDS: a tin
           that only starts after this baby's bracket has ended is not a
           "close option", it is the wrong product. Older babies may be shown
           formulas meant for younger ones; never the other way round. */
        if (ignore.age && S.age && AGE_END[S.age] !== null &&
            p.ageMin !== null && p.ageMin >= AGE_END[S.age]) return false;
        if (!ignore.milk && S.milk && S.milk !== "any" && p.milk !== S.milk) return false;
        if (S.need && S.need !== "none" && p.need.indexOf(S.need) < 0) return false;
        return true;
      }).sort(function (a, b) {
        var ai = a.avail && a.qty > 0, bi = b.avail && b.qty > 0;
        if (ai !== bi) return ai ? -1 : 1;
        return b.qty - a.qty;
      });
    }

    function inStock(p) { return p.avail && p.qty > 0; }

    function pill(p) {
      if (!inStock(p)) return '<span class="bpff-pill bpff-pill--out">Out of stock</span>';
      if (p.qty <= 5) return '<span class="bpff-pill bpff-pill--low">Only ' + p.qty + ' left</span>';
      return '<span class="bpff-pill bpff-pill--in">In stock &middot; ships today</span>';
    }

    function card(p) {
      var key = p.b.toLowerCase().replace(/[^a-z]/g, "");
      var bc = BRAND[key] || "var(--bpff-forest)";
      var av = p.img
        ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="46" height="46">'
        : esc(p.b.slice(0, 2).toUpperCase());
      var meta = ageLabel(p.ageMin, p.ageMax) + (p.milk ? " · " + p.milk + " milk" : "");
      return '<a class="bpff-card" href="/products/' + esc(p.h) + '">' +
        '<span class="bpff-card__av" style="--bpff-bc:' + bc + '">' + av + '</span>' +
        '<span><span class="bpff-card__t">' + esc(p.t) + '</span>' +
        '<span class="bpff-card__m">' + esc(meta) + '</span>' +
        '<span class="bpff-card__f"><span class="bpff-card__p">' + esc(p.money) + '</span>' +
        pill(p) + '</span></span></a>';
    }

    function setCta(label, href, off) {
      $("ctatext").textContent = label;
      var cta = $("cta");
      cta.setAttribute("href", href || COLLECTION_URL);
      cta.classList.toggle("is-off", !!off);
      if (off) cta.setAttribute("aria-disabled", "true"); else cta.removeAttribute("aria-disabled");
    }

    /* On a phone the three questions stack ABOVE the results, so the answer to
       the third tap lands a screen and a half below the fold. Bring the results
       into view — but only when they are genuinely off screen, so a parent
       already reading the list is never yanked around.

       No behavior:"smooth" here. It is silently a no-op in some embedded
       webviews (verified 22 Sep 2026): scrollIntoView gets called, nothing
       moves, and the whole feature quietly does nothing. The default instant
       jump works everywhere; scroll-margin-top in the CSS keeps the heading
       clear of the sticky header. */
    function maybeRevealResults() {
      if (window.innerWidth > NARROW) return;
      if (!(S.age && S.milk && S.need)) return;
      var panel = ROOT.querySelector(".bpff__r");
      if (!panel) return;
      if (panel.getBoundingClientRect().top > window.innerHeight * 0.75) {
        panel.scrollIntoView({ block: "start" });
      }
    }

    function render() {
      ["age", "milk", "need"].forEach(function (k, n) {
        var bar = $("p" + n); if (bar) bar.classList.toggle("is-on", !!S[k]);
        var qb = ROOT.querySelector('[data-bpff-qb="' + k + '"]');
        if (qb) qb.classList.toggle("is-on", !!S[k]);
      });

      var out = $("out");
      var answered = ["age", "milk", "need"].filter(function (k) { return S[k]; }).length;
      var done = answered === 3;

      if (FAILED) {
        $("stat").hidden = true;
        $("kick").textContent = "Your matches";
        $("rh").textContent = "We can't load the shelf right now";
        $("rsub").textContent = "";
        out.innerHTML = '<div class="bpff-hint"><p>Text us at ' + esc(PHONE) +
          " and we'll find the right stage for you in a minute.</p></div>";
        setCta("Browse all formulas", COLLECTION_URL, false);
        return;
      }

      if (!done) {
        $("stat").hidden = true;
        setCta("Answer " + (3 - answered) + " question" + (3 - answered === 1 ? "" : "s"), null, true);
        $("kick").textContent = "Your matches";
        if (!S.age) {
          $("rh").textContent = "Answer the three questions";
          $("rsub").textContent = "We'll narrow " + TOTAL + " formulas down to the ones that actually fit.";
        } else if (!P) {
          $("rh").textContent = "Checking the shelf…";
          $("rsub").textContent = "";
        } else {
          var n = sel({}).length;
          $("rh").innerHTML = "<b>" + n + "</b> formula" + (n === 1 ? "" : "s") + " so far";
          $("rsub").textContent = n ? "Keep going — the next answer narrows it further."
                                    : "Nothing so far. The next answers may still open it up.";
        }
        out.innerHTML = '<div class="bpff-hint">' + I.search +
          "<p>Your matches will appear here as you answer — and if nothing fits, we'll say so.</p></div>";
        return;
      }

      if (!P) {
        $("stat").hidden = true;
        $("rh").textContent = "Checking the shelf…";
        $("rsub").textContent = "";
        out.innerHTML = '<div class="bpff-hint"><p>One moment — pulling today\'s stock.</p></div>';
        setCta("Checking…", null, true);
        loadCatalogue();
        return;
      }

      /* ---- the fallback ladder ----------------------------------------
         ONE answer may be relaxed, never two. The old code's last step
         dropped the age AND the milk base at once, so "24+ months / goat
         milk / spitting up" answered with cow anti-reflux formulas for
         NEWBORNS — contradicting two of the three answers the parent gave,
         under a banner that only mentioned the age.

         Milk is relaxed before age because it is a preference, while age is
         a safety boundary, and the age relaxation is one-directional (see
         sel()). If neither single relaxation finds anything, say so. An
         honest empty answer is the point of this section. */
      var list = sel({}), mode = "exact";
      if (!list.length && S.milk && S.milk !== "any") {
        list = sel({ milk: 1 }); if (list.length) mode = "milk";
      }
      if (!list.length) {
        var alt = sel({ age: 1 }); if (alt.length) { list = alt; mode = "age"; }
      }

      var stocked = list.filter(inStock);
      var brands = {}; list.forEach(function (p) { brands[p.b] = 1; });
      var brandCount = Object.keys(brands).length;

      $("kick").textContent = mode === "exact" ? "Your matches" : "Closest options";

      if (!list.length) {
        $("rh").textContent = "Nothing matches that combination";
        $("rsub").textContent = "Which usually means no European brand makes it.";
      } else if (S.need === "none") {
        $("rh").innerHTML = "<b>" + list.length + "</b> formulas for " + AGEL[S.age].toLowerCase() +
          (S.milk === "any" ? "" : ", " + MILKL[S.milk]);
        $("rsub").textContent = "Sorted with what we can ship today first.";
      } else {
        $("rh").innerHTML = "<b>" + list.length + "</b> formula" + (list.length === 1 ? "" : "s") +
          " for " + NEEDL[S.need];
        $("rsub").textContent = AGEL[S.age] +
          (mode === "milk" ? " · cow milk instead"
           : mode === "age" ? " · other ages"
           : S.milk === "any" ? "" : " · " + MILKL[S.milk]);
      }

      $("stat").hidden = !list.length;
      $("n1").textContent = list.length;
      $("n2").textContent = stocked.length;
      $("n3").textContent = brandCount;

      var html = "";
      if (mode === "milk") html += '<div class="bpff-swap"><b>No goat formula is made for this</b>' +
        '<p>Goat milk is naturally gentle, but no goat brand makes a formula specifically for ' +
        NEEDL[S.need] + '. Here is what actually does.</p></div>';
      if (mode === "age") html += '<div class="bpff-swap"><b>Not made for this age</b>' +
        '<p>No ' + (S.milk && S.milk !== "any" ? MILKL[S.milk] + " " : "") +
        'formula for ' + NEEDL[S.need] + ' is made for ' + AGEL[S.age].toLowerCase() +
        '. These are made for younger babies — <b>check the age on each one</b> before you order.</p></div>';
      if (S.need === "ha") html += '<div class="bpff-swap bpff-swap--rose"><b>If it is a real reaction, call your doctor first</b>' +
        '<p>Rash, swelling around the mouth, blood in the stool or repeated vomiting need a pediatrician, ' +
        "not a different tin. HA formula is gently hydrolysed and is what families often try when a baby " +
        "seems unsettled on cow's milk — but it is <b>not</b> a treatment for a diagnosed cow's milk " +
        "allergy (CMA or CMPA). That needs an extensively hydrolysed formula, which is the next option " +
        "down the list.</p></div>";
      if (S.need === "cmpa") html += '<div class="bpff-swap bpff-swap--rose"><b>Please read before ordering</b>' +
        "<p>These are extensively hydrolysed formulas for babies with a <b>diagnosed</b> cow's milk allergy " +
        "— your doctor may call it CMA or CMPA — and they are normally started under medical " +
        "supervision. If nobody has diagnosed it yet, a pediatrician is the right first call — not a " +
        "different tin.</p></div>";
      if (S.need === "lactose") html += '<div class="bpff-swap bpff-swap--rose"><b>Worth knowing</b>' +
        "<p>True lactose intolerance in babies is uncommon, and when it does happen it is usually temporary " +
        "— after a stomach bug, for a few weeks. Lactose is also the main carbohydrate in breast milk, so " +
        "this is a switch worth making with your pediatrician rather than on a hunch.</p></div>";

      if (list.length) {
        var shown = EXPANDED ? list : list.slice(0, 6);
        html += '<div class="bpff-cards">' + shown.map(card).join("") + "</div>";
        if (list.length > 6) {
          html += '<button type="button" class="bpff-more" data-bpff-more>' +
            (EXPANDED ? "Show fewer" : "Show all " + list.length + " matches") + "</button>";
        }
        var top = stocked.length ? stocked[0] : list[0];
        setCta(inStock(top) ? "View the top match" : "See what else we stock",
               inStock(top) ? "/products/" + top.h : COLLECTION_URL, false);
      } else {
        html += '<div class="bpff-hint"><p>Text us at ' + esc(PHONE) + " and we'll tell you honestly " +
          "what the closest option is — or that there isn't one.</p></div>";
        setCta("Browse all formulas", COLLECTION_URL, false);
      }
      out.innerHTML = html;
    }

    /* ---------- build the question column ---------- */
    var qcol = $("qcol");
    GROUPS.slice().reverse().forEach(function (g) {
      var d = document.createElement("div");
      d.className = "bpff-qb " + g.cls;
      d.setAttribute("data-bpff-qb", g.k);
      d.innerHTML = '<div class="bpff-qb__h"><span class="bpff-qb__ico">' + I[g.ico] + "</span>" +
        '<span class="bpff-qb__t">' + g.q + (g.sub ? "<small>" + g.sub + "</small>" : "") + "</span></div>" +
        '<div class="bpff-opts' + (g.cols === 3 ? " bpff-opts--3" : "") + '" data-bpff-group="' + g.k + '">' +
        g.o.map(function (o) {
          return '<button type="button" class="bpff-opt" data-v="' + o[0] + '" aria-pressed="false">' +
            '<span class="bpff-opt__i">' + I[o[3]] + "</span><span>" + o[1] +
            (o[2] ? "<em>" + o[2] + "</em>" : "") + "</span></button>";
        }).join("") + "</div>";
      qcol.insertBefore(d, qcol.firstChild);
    });
    $("eyebrow").innerHTML = I.search + esc(EYEBROW);

    /* ---------- events ---------- */
    ROOT.addEventListener("click", function (e) {
      if (e.target.closest("[data-bpff-more]")) { EXPANDED = !EXPANDED; render(); return; }

      var b = e.target.closest(".bpff-opt");
      if (b) {
        var g = b.closest("[data-bpff-group]");
        Array.prototype.forEach.call(g.querySelectorAll(".bpff-opt"), function (o) {
          o.setAttribute("aria-pressed", "false");
        });
        b.setAttribute("aria-pressed", "true");
        S[g.getAttribute("data-bpff-group")] = b.getAttribute("data-v");
        EXPANDED = false;
        loadCatalogue();
        render();
        maybeRevealResults();
        return;
      }

      if (e.target.closest('[data-bpff="reset"]')) {
        S.age = S.milk = S.need = null; EXPANDED = false;
        Array.prototype.forEach.call(ROOT.querySelectorAll(".bpff-opt"), function (o) {
          o.setAttribute("aria-pressed", "false");
        });
        render();
      }
    });

    /* Prefetch as soon as the section comes near the viewport, so the first
       tap feels instant. Falls back to fetching on first tap. */
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); loadCatalogue(); }
      }, { rootMargin: "400px" });
      io.observe(ROOT);
    } else {
      loadCatalogue();
    }

    render();
  }

  function boot(scope) {
    var nodes = (scope || document).querySelectorAll(".bpff-root");
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(); });
  } else {
    boot();
  }

  /* Theme editor: a re-rendered section arrives with a fresh DOM. */
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
})();
